
  <div class="side-nav">
    <div>
      <app-nav-items></app-nav-items>
      <app-sign-up-button></app-sign-up-button>
    </div>
  </div>
